"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHashesByKeyMap = exports.lambdaProfileToContentProfile = void 0;
const lambdaProfileToContentProfile = (profile) => {
    return Object.assign(Object.assign({}, profile), { avatars: profile.avatars.map(avatar => (Object.assign(Object.assign({}, avatar), { avatar: Object.assign(Object.assign({}, avatar.avatar), { snapshots: Object.entries(avatar.avatar.snapshots)
                    .map(([key, value]) => ({
                    [key]: value.replace(/.*\//, '')
                }))
                    .reduce((acc, curr) => {
                    return Object.assign(Object.assign({}, acc), curr);
                }, {}) }) }))) });
};
exports.lambdaProfileToContentProfile = lambdaProfileToContentProfile;
const getHashesByKeyMap = (avatar) => {
    const hashesByKey = new Map();
    Object.entries(avatar.avatar.snapshots).forEach(([key, value]) => {
        hashesByKey.set(`${key}.png`, value);
    });
    return hashesByKey;
};
exports.getHashesByKeyMap = getHashesByKeyMap;
//# sourceMappingURL=utils.js.map